import { graphql } from '../../../../gql'

export const UPDATE_CHANNEL_POSTING_GOAL_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateChannelPostingGoal($input: UpdateChannelPostingGoalInput!) {
    updateChannelPostingGoal(input: $input) {
      __typename
      ... on UpdateChannelPostingGoalResponse {
        channel {
          id
          postingGoal {
            goal
            sentCount
            scheduledCount
            periodStart
            periodEnd
            status
          }
        }
      }
      ... on MutationError {
        message
      }
    }
  }
`)
